export default __webpack_public_path__ + "static/media/lock-icon.ef948081.svg";